import { useEffect, useState } from "react";
import axios from "axios";
import LoadingModal from "../utils/LoadingModal";
// import { TransferTableFranchise } from "./DashboardComponents/TransferTableFranchise";
import Charts from "../Common/Charts"
export default function DashboardFranchise() {
  const [refetch, setRefetch] = useState(false);
  const [franchise, setFranchise] = useState(null);
  const [loading, setLoading] = useState(false);
  const [outcomingstock, setoutcomingstock] = useState(0);

  const getfullinfo = async (event) => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}auth/check/`,
        { withCredentials: true }
      );

      const userId = response.data?.data?._id;
      const franchiseInfo = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}franchise/${userId}/`,
        { withCredentials: true }
      );
      setFranchise(franchiseInfo.data);
    } catch (error) {
      console.error("Error fetching franchise data:", error);
    }
    setLoading(false);
  };
  const getUserPendingTransactionsAmount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}userPendingTransactionsAmount`,
        {
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        setoutcomingstock(response.data.totalPendingAmount);
      }
    } catch (error) {
      console.error("Error fetching user pending transactions amount:", error);
    }
  };

  const refetchData = () => {
    setRefetch(!refetch);
  };

  useEffect(() => {
    getfullinfo();
    getUserPendingTransactionsAmount();
  }, [refetch]);

  return (
    <div>
      {loading && <LoadingModal></LoadingModal>}
      <div className="dark:bg-gray-900 ">
        <>
          <div className="grid w-full grid-cols-1 gap-4 mt-4 xl:grid-cols-2 2xl:grid-cols-2 mb-4">
            <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800">
              <div className="w-full">
                <h3 className="text-base font-normal text-gray-500 dark:text-gray-400">
                  Votre stock
                </h3>
                <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
                  {franchise?.StockTotal}
                </span>
              </div>
            </div>
            <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800">
              <div className="w-full">
                <h3 className="text-base font-normal text-gray-500 dark:text-gray-400">
                  Stock sortant en attente d'acceptation
                </h3>
                <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
                  {outcomingstock}
                </span>
              </div>
            </div>
          </div>
          {/* <div className="grid w-full grid-cols-1 gap-4 mt-4 xl:grid-cols-1 2xl:grid-cols-1 mb-4">
            <TransferTableFranchise
            userId= {franchise?.user}
            refetchData={refetchData}
            />
          </div> */}
          <Charts />
        </>
      </div>
    </div>
  );
}
